import beTwMerge from '@/utils/beTwMerge';

export type MissionTileIconProps = {
  eyebrow?: {
    label: string;
    weight: string;
    lineBreak: boolean;
  };
  icon: string | React.ReactNode;
  isFourIcons?: boolean;
  subCopy?: {
    label?: string;
    href?: string;
    lineBreak?: boolean;
    weight: string;
  };
  target?: string;
  iconTextColor?: string;
};

export default function MissionTileIcon({
  icon,
  eyebrow,
  subCopy,
  isFourIcons = false,
  target = '_self',
  iconTextColor,
}: MissionTileIconProps) {
  let media: any;
  if (icon) {
    if (typeof icon === 'string') {
      media = (
        <img
          alt={eyebrow?.label || ''}
          className="tw-w-[56px] tw-h-[56px] md:tw-w-[100px] md:tw-h-[100px]"
          height={100}
          loading="lazy"
          src={icon}
          width={100}
        />
      );
    } else {
      media = icon;
    }
  }

  let subCopyContent = subCopy?.label && (
    <p
      className={beTwMerge(
        'tw-mb-0 tw-font-book tw-text-be-xs md:tw-text-be-sm',
        subCopy?.lineBreak ? 'tw-whitespace-normal' : 'tw-whitespace-nowrap',
        subCopy?.weight === '800' && 'tw-font-heavy'
      )}
    >
      {subCopy.label}
    </p>
  );

  if (subCopy?.href && subCopyContent) {
    subCopyContent = (
      <a
        href={subCopy.href}
        target={target}
        className="tw-text-color-white hover:tw-text-color-light-green-light"
        style={{ color: iconTextColor }}
      >
        {subCopyContent}
      </a>
    );
  }

  return (
    <div
      className={beTwMerge(
        'tw-w-[calc(33%-10px)] md:tw-w-[155px] lg:tw-w-[300px] tw-text-center',
        isFourIcons && 'tw-w-[155px]'
      )}
    >
      <div>
        {media && <div className={beTwMerge((eyebrow?.label || subCopy?.label) && 'tw-mb-3 md:tw-mb-4')}>{media}</div>}
        {eyebrow?.label && (
          <div
            className={beTwMerge(
              'tw-font-book tw-break-words tw-text-be-s tw-uppercase',
              eyebrow?.weight === '800' && 'tw-font-heavy',
              eyebrow?.lineBreak ? 'tw-whitespace-normal' : 'tw-whitespace-nowrap',
              subCopy?.label && 'tw-mb-0.5 md:tw-mb-1'
            )}
          >
            {eyebrow?.label}
          </div>
        )}
        {subCopy?.label && subCopyContent}
      </div>
    </div>
  );
}
